/**
 * /cart page enhancement — same /cart/change.js flow as the drawer; after a
 * mutation the page section re-renders in place (Section Rendering API).
 */
(function () {
  'use strict';

  function init(page) {
    if (page.dataset.cartPageInit) return;
    page.dataset.cartPageInit = '1';

    var errorEl = page.querySelector('[data-cart-page-error]');
    var busy = false;

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message || errorEl.getAttribute('data-fallback') || '';
      errorEl.hidden = false;
    }

    function refresh(cart) {
      // JSON-template section ids are dynamic — read the real one from the DOM
      var wrapper = page.closest('.shopify-section');
      var sectionId = wrapper ? wrapper.id.replace('shopify-section-', '') : '';
      if (!sectionId) { window.location.reload(); return; }

      fetch(window.location.pathname + '?sections=' + sectionId)
        .then(function (res) { return res.json(); })
        .then(function (sections) {
          var key = Object.keys(sections)[0];
          if (!key) return;
          var doc = new DOMParser().parseFromString(sections[key], 'text/html');
          var fresh = doc.querySelector('[data-cart-page]');
          if (fresh) {
            page.innerHTML = fresh.innerHTML;
            delete page.dataset.cartPageInit;
            init(page);
          }
          document.dispatchEvent(new CustomEvent('dylys:cart-change', {
            detail: { cart: cart, source: 'cart-page' }
          }));
        })
        .catch(function () { showError(); });
    }

    page.querySelectorAll('[data-cart-line]').forEach(function (row) {
      var line = parseInt(row.getAttribute('data-line-index'), 10);
      var value = row.querySelector('.cart-line__qty-value');
      var read = function () { return parseInt(value ? value.textContent : '1', 10) || 1; };

      var change = function (quantity) {
        if (busy) return;
        busy = true;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: line, quantity: quantity })
        })
          .then(function (res) {
            return res.json().then(function (data) { return { ok: res.ok, data: data }; });
          })
          .then(function (result) {
            busy = false;
            if (!result.ok) {
              showError(result.data && (result.data.description || result.data.message));
              return;
            }
            refresh(result.data);
          })
          .catch(function () {
            busy = false;
            showError();
          });
      };

      var dec = row.querySelector('[data-line-decrease]');
      var inc = row.querySelector('[data-line-increase]');
      var rem = row.querySelector('[data-line-remove]');
      if (dec) dec.addEventListener('click', function () { change(Math.max(0, read() - 1)); });
      if (inc) inc.addEventListener('click', function () { change(read() + 1); });
      if (rem) rem.addEventListener('click', function () { change(0); });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-cart-page]').forEach(init);
  }

  initAll();

  document.addEventListener('shopify:section:load', initAll);
})();
